import {
  codeOk,
  codeError,
  emptyFieldMessage,
  invalidFieldMessage,
} from "./notification/notification";
import { Responses } from "./responses/responses";

type ValidationResult = ReturnType<typeof Responses>;

const isBlank = (value: unknown): boolean =>
  value === null || value === undefined || value === "";

export const requireFields = (
  fields: Record<string, unknown>,
): ValidationResult => {
  for (const [label, value] of Object.entries(fields)) {
    if (isBlank(value)) {
      return Responses(true, codeError, emptyFieldMessage(label));
    }
  }
  return Responses(false, codeOk, "validation passed");
};

export const validatePassword = (password: unknown): ValidationResult => {
  if (isBlank(password) || String(password).length < 6) {
    return Responses(true, codeError, invalidFieldMessage("Password"));
  }
  return Responses(false, codeOk, "validation passed");
};
